<template>
	<section class="com-b-wrap">
		<div class="com-title" style="margin-left: -0.53rem">
<!--      <span >所有客户</span>-->
			<HXScroll :list="allCustomer" @change="hxsChange">
				<template slot="start">
					<span @click="hxsChange('')" >所有客户<i class="el-icon-d-arrow-right" v-if="allCustomer.length>0"></i></span>
				</template>
			</HXScroll>

		</div>
		<div class="com-table-wrap">

			<el-col :span="24" class="toolbar" style="padding-bottom: 0px; text-align: left;">
				<el-form :inline="true" :model="queryParam">
					<el-form-item label="筛选条件">
						<el-input v-model="queryParam.inviterName" placeholder="推广来源"></el-input>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryParam.userLevel" placeholder="所有用户等级">
							<!-- 		<el-option v-for="item in [{value:'0',label:'所有等级'},{value:'1',label:'一级'},{value:'2',label:'二级'},{value:'3',label:'其他'}]"
									 :key="item.value" :label="item.label" :value="item.value">
									</el-option> -->
							<el-option v-for="(value,name) in userLevelMap" :key="value" :label="value" :value="name">
							</el-option>
						</el-select>
					</el-form-item>
					<!--<el-form-item>-->
						<!--<el-select v-model="queryParam.userType" placeholder="全部类型">-->
							<!--<el-option v-for="item in [{value:'',label:'所有用户'},{value:'0',label:'个人用户'},{value:'1',label:'企业用户'}]" :key="item.value"-->
							 <!--:label="item.label" :value="item.value">-->
							<!--</el-option>-->
						<!--</el-select>-->
					<!--</el-form-item>-->
					<el-form-item>
						<el-date-picker v-model="queryParam.inviteTime" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
						 value-format="yyyy-MM-dd" :picker-options="{shortcuts: [
					                    {text: '最近一周', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    },
					                    {text: '最近一个月', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    },
					                    { text: '最近三个月', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    }] }">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="queryList()">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<el-table :data="pageListData" v-loading="loading" highlight-current-row style="width: 100%" size="medium"
			 row-class-name="listRow" @row-click="rowClick">
				<el-table-column header-align="center" align="center" prop="userName" label="名称">
					<template slot-scope="scope">
						{{scope.row.userName}}
						<!-- 					<template v-else-if="$store.getters.root">
							<router-link :to="{path: '/pages/myCustomer.html',query:{inviter: scope.row.userId}}">{{scope.row.userName}}</router-link>
						</template>
						<template v-else-if="$store.getters.userId == scope.row.inviter">
							<router-link :to="{path: '/pages/myCustomer.html',query:{inviter: scope.row.userId}}">{{scope.row.userName}}</router-link>
						</template>
						<template v-else="">{{scope.row.userName}}</template> -->
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="userAccount" label="用户账号"></el-table-column>
				<!--<el-table-column header-align="center" align="center" prop="userType" label="用户类型">-->
					<!--<template slot-scope="scope">-->
						<!--<template v-if="scope.row.userType == 0">个人</template><template v-else="">企业</template>-->
					<!--</template>-->
				<!--</el-table-column>-->
				<el-table-column header-align="center" align="center" prop="userLevel" label="用户等级">
					<template slot-scope="scope">
						<!-- {{scope.row.userLevel && userLevelMap[scope.row.userLevel]}} -->
							{{scope.row.userLevel}}
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="inviterName" label="推广来源"></el-table-column>
				<el-table-column header-align="center" align="center" prop="identificationStatus" label="认证状态">
					<template slot-scope="scope">
						<template v-if="scope.row.identificationStatus == 3">
							<el-popover trigger="click">
								<ul class="ul-table">
									<li>
										<template v-if="scope.row.userType == 0">
											<label class="title">姓名:</label>
										</template>
										<template v-else="">
											<label class="title">法人名称:</label>
										</template>
										<label class="value">{{IdentificationInfo.name}}</label>
									</li>
									<li>
										<template v-if="scope.row.userType == 0">
											<label class="title">手机号码:</label>
										</template>
										<template v-else="">
											<label class="title">法人手机:</label>
										</template>
										<label class="value">{{IdentificationInfo.phone}}</label>
									</li>
								</ul>
								<el-button type="text" slot="reference" @click="queryIdentificationInfo(scope.row.userId, scope.row.userType)">已实名</el-button>
							</el-popover>
						</template>
						<template v-else>未实名</template>
					</template>
				</el-table-column>
        <el-table-column header-align="center" align="center" prop="point" label="剩余积分"></el-table-column>
				<el-table-column header-align="center" align="center" prop="userRegisterTime" label="注册时间">
					<template slot-scope="scope">{{scope.row.userRegisterTime | formatDateTime}}</template>
				</el-table-column>
				<!-- <el-table-column header-align="center" align="center" prop="agentAble" label="推广状态">
					<template slot-scope="scope">
						<el-switch :value="scope.row.agentAble=='1'?true:false" @change="scope.row.agentAble == '1'?stopAgent(scope.row.userId):openAgent(scope.row.userId)"
						 active-color="#00B1FF" inactive-color="#D8D8D8">
						</el-switch>
					</template>
				</el-table-column> -->
				<el-table-column header-align="center" align="center" label="操作" fixed="right" width="200">
					<template slot-scope="scope">
						<!-- <el-button type="text" v-if="scope.row.agentAble != 2" size="small" @click="openSuperAgent(scope.row.userId)">代理推广</el-button> -->
						<el-button type="text" size="small" @click="pointHistory(scope.row.userId)">积分明细</el-button>
						<el-button type="text" size="small" @click="zhJF(scope.row)">转赠积分</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-block" style="text-align: right;padding: 30px;">
				<el-pagination v-if="paged.total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange" :total="paged.total"
				 :current-page.sync="paged.page" :page-size="paged.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</div>

			<!-- 转赠积分 -->
			<el-dialog custom-class="com-dialog" :show-close="false" title="转赠积分" :visible.sync="dialogZZ">
				<div>
					<el-form :model="modelZZ" :rules="rulesZZ" ref="ruleFormZZ" label-width="100px" class="dialog-form">
						<el-form-item label="转赠账号：" prop="name">
							<el-input :value="modelZZ.userAccount" :disabled="true" placeholder="电话/账号" />
						</el-form-item>
						<el-form-item label="当前积分：" prop="name">
							<span class="normal">{{modelZZ.currentPoint}}</span>
						</el-form-item>
						<el-form-item label="转赠积分：" prop="point">
							<el-input v-model.number="modelZZ.point" placeholder="请输入" type="number" />
						</el-form-item>
					</el-form>
					<div class="footer" slot="footer">
						<el-button @click="dialogZZ = false">取 消</el-button>
						<el-button type="primary" @click="submitFormZZ('ruleFormZZ')" :loading="loadingZZ" :disabled="loadingZZ">确 定</el-button>
					</div>
				</div>
			</el-dialog>

		</div>

	</section>
</template>

<script>
	import http from '@/http'
	import HXScroll from '../common/HXScroll.vue'

	export default {
		components: {
			HXScroll: HXScroll
		},
		data() {
			return {
				userLevelMap: {
					0: '所有等级',
					1: '一级',
					2: '二级',
					3: '其他'
				},
				queryParam: {
					// recursion: 0
				},
				paged: {
					page: 1,
					pageSize: 10
				},
				pageListData: [],
				pathList: [],
				loading: false,
				IdentificationInfo: {
					name: '',
					phone: ''
				},
				allCustomer: [], // 所有用户
				// 转赠积分
				loadingZZ: false,
				dialogZZ: false,
				modelZZ: {
					userAccount: '',
					currentPoint: '',
					point: '' // 转赠积分
				},
				rulesZZ: {
					point: [{
							// type: 'integer',
							required: true,
							message: '请输入转赠积分'
						},
						{
							validator: this.$validatorInteger,
							trigger: 'blur'
						}
					]
				}
			}
		},
		watch: {
			'$route'(route) {
				this.queryList();
			}
		},
		mounted() {
			this.searchIntegral();
			this.queryList();
		},
		methods: {
			handleCurrentChange: function(val) {
				this.paged.page = val;
				this.queryList();
			},
			handleSizeChange: function(val) {
				this.paged.pageSize = val;
				this.queryList();
			},
			// 横向滚动点击
			hxsChange(id) {
				this.queryParam = { // 每次点击上面的用户都清空列表参数
					...this.$clearObj(this.queryParam),
					inviter: id
				}
				this.paged = { // 重置分页
					page: 1,
					pageSize: 10
				}
				// this.getUserList(id)
				this.queryList()
				// 删除节点后面的数据
				if (id != '') {
					this.allCustomer = this.allCustomer.slice(0, this.allCustomer.findIndex(item => item.value == id) + 1)
				} else {
					this.allCustomer = []
				}
			},
			/**
			 * 获取顶部用户列表
			 * */
			getUserList(userId) {
				var _this = this;
				_this.allCustomer = []
				http.get(_this.globalConfig.domain.backstage + "/admin/getUserInfoById?userId=" + userId, (response) => {
					if (response.data && response.data.success && response.data.data) {
						let data = response.data.data.split(',')
						data = data.length > 0 ? data : []
						let allCustomer = data.map(item => {
							let arr = item.split('-')
							return {
								value: arr ? arr[0] : '',
								label: arr ? arr[1] : '',
							}
						})
						_this.allCustomer = allCustomer
					}
				});
			},
			// 点击行查询下级信息
			rowClick(row, column, event) {

				if (!row.userId) return
				this.getUserList(row.userId)
			},
			// 查询当前登录用户积分
			searchIntegral() {
				var _this = this;
				http.get(_this.globalConfig.domain.backstage + "/admin/queryUserById", (response) => {
					if (response.data && response.data.success) {
						_this.modelZZ.currentPoint = response.data.data.point
					}
				});
			},
			// 转赠积分提交
			submitFormZZ(formName) {
				var _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.loadingZZ = true
						let param = {
							point: _this.modelZZ.point,
							userAccount: _this.modelZZ.userAccount
						}
						http.post(_this.globalConfig.domain.backstage + "/admin/sendUserPoint", param, (response) => {
							_this.loadingZZ = false
							if (response.data && response.data.success) {
								_this.$message.success("操作成功");
								this.dialogZZ = false
								// 清空表单
								_this.modelZZ = {
									..._this.modelZZ,
									point: ''
								}
								this.searchIntegral()
								// _this.modelZZ.currentPoint = response.data.data.point
							} else {
								_this.$message.success(response.data.message);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 转赠积分
			zhJF(item) {
				this.modelZZ.userAccount = item.userAccount || ''
				this.dialogZZ = true
			},
			queryList: function() {
				var _this = this;
				_this.pageListData = [];
				_this.pathList = [];
				_this.loading = true;
				var merge = require('webpack-merge');
				let obj = {
					inviteTimeStart: _this.queryParam.inviteTime ? _this.queryParam.inviteTime[0] : '',
					inviteTimeEnd: _this.queryParam.inviteTime ? _this.queryParam.inviteTime[1] : ''
				}
				let param = merge({}, _this.$route.query, _this.queryParam, obj, _this.paged);

				http.post(_this.globalConfig.domain.backstage + "/admin/queryUserInvite", param, (response) => {
					let result = response.data;
					if (result.success) {
						_this.pageListData = result.data.listData;
						_this.pathList = result.data.pathList;
						_this.paged = result.data.paged;
					} else {
						_this.$message.error(result.message);
					}
					_this.loading = false;
				});
			},
			openAgent: function(userId) {
				var _this = this;
				this.$confirm('为此用户开启普通推广功能,是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					http.post(_this.globalConfig.domain.backstage + "/admin/openAgent", {
						userId: userId
					}, (response) => {
						let result = response.data;
						if (result.success) {
							_this.queryList();
							_this.$message.success("操作成功");
						} else {
							_this.$message.error("操作失败");
						}
						_this.loading = false;
					});
				}).catch(() => {})
			},
			stopAgent: function(userId) {
				var _this = this;
				this.$confirm('为此用户停用推广功能,是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					http.post(_this.globalConfig.domain.backstage + "/admin/stopAgent", {
						userId: userId
					}, (response) => {
						let result = response.data;
						if (result.success) {
							_this.queryList();
							_this.$message.success("操作成功");
						} else {
							_this.$message.error("操作失败");
						}
						_this.loading = false;
					});
				}).catch(() => {})
			},
			/**
			 * 积分明细
			 * */
			pointHistory: function(userId) {
				this.$router.push({
					path: '/invite/pointHistory.html',
					query: {
						userId: userId
					}
				})
			},
			/**
			 * 代理推广
			 * */
			openSuperAgent: function(userId) {
				var _this = this;
				this.$confirm('为此用户开启代理推广功能,是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					http.post(_this.globalConfig.domain.backstage + "/admin/openSuperAgent", {
						userId: userId
					}, (response) => {
						let result = response.data;
						if (result.success) {
							_this.queryList();
							_this.$message.success("操作成功");
						} else {
							_this.$message.error("操作失败");
						}
						_this.loading = false;
					});
				});
			},

			queryIdentificationInfo: function(userId, userType) {
				var _this = this;
				_this.IdentificationInfo = {
					name: '',
					phone: ''
				}
				http.post(_this.globalConfig.domain.backstage + "/admin/certificationInfo", {
					userId: userId,
					userType: userType
				}, (response) => {
					let result = response.data;
					if (result.success) {
						_this.IdentificationInfo = result.data;
					} else {
						_this.$message.error("查询失败");
					}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	// .com-b-wrap {
	// 	background-color: #FFFFFF;
	// }

	// .com-title {
	// 	margin-bottom: 25px;
	// }

	.listRow {
		height: 60px;
	}

	.ul-table {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.ul-table li {
		height: 30px;
		display: block;
		line-height: 30px;
	}

	.ul-table .title {
		background-color: #EDF3F4;
		display: table-cell;
		width: 80px;
		text-align: right;
	}

	.ul-table .value {
		background-color: #ECF0F5;
		width: 120px;
		display: table-cell;
		padding-left: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/MyCustomer.vue